export default __webpack_public_path__ + "static/media/logo.c39a560a.webp";